import { render, staticRenderFns } from "./PickupAgentSlider.vue?vue&type=template&id=5fc46b6a&"
import script from "./PickupAgentSlider.vue?vue&type=script&lang=js&"
export * from "./PickupAgentSlider.vue?vue&type=script&lang=js&"
import style0 from "./PickupAgentSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabs})
